import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';
import { WalletService } from 'library-explorer';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class UtilitiesService {

  public isNative: boolean;
  apiUrl: string = environment.apiUrl;
  domain: string = environment.appUrl;

  constructor(private router: Router, private walletService: WalletService) { }

  init() {
    this.isNative = Capacitor.isNativePlatform();
    if (this.isNative) this.router.navigateByUrl('native');

    this.getWalletSettings();
  }

  async openCapacitorSite(url: string){
    await Browser.open({ url });
  };

  navigateBack() {
    window.history.back();
  }

  getWalletSettings() {
    this.walletService.fetchWalletSettings().subscribe();
  }
}
